<template>
  <div class="newAddress">
    <div class="top"></div>
    <van-nav-bar
      :title="aid ? '编辑地址' : '新增地址'"
      left-text="返回"
      left-arrow
      :fixed="true"
      @click-left="back"
    />

    <van-address-edit
      :area-list="areaList"
      show-postal
      :show-delete="aid ? true : false"
      show-set-default
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      :address-info="addressInfo"
      :is-saving="issaving"
      :is-deleting="isdelete"
      @save="saveAddress"
      @delete="removeAddress"
    />
  </div>
</template>

<script>
import "../assets/less/newAddress.less";
import areaList from "../assets/js/arealist";
import { utils } from "../assets/js/Utils";
export default {
  data() {
    return {
      areaList,
      //地址数据初始值
      // id: "",   暂时不需要
      addressInfo: {
        name: "",
        tel: "",
        province: "",
        city: "",
        county: "",
        addressDetail: "",
        areaCode: "",
        postalCode: "",
        isDefault: false,
      },
      aid: "",
      issaving: false,
      isdelete: false,
    };
  },

  created() {
    // 获取aid
    this.aid = this.$route.query.aid;

    if (this.aid) {
      this.getAddressDataByAid();
    }
  },

  methods: {
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 新增地址
    newAddress(address) {
      // 复制一个对象，避免改到原始数据
      let content = Object.assign({}, address);

      let tokenString = localStorage.getItem("TK");
      if (!toString) {
        return this.$router.push({ name: "Login" });
      }

      // 删除多余的数据
      delete content.country;

      // 将布尔值转变成num
      content.isDefault = Number(content.isDefault);

      // 添加接口需要的数据，appkey和token
      content.appkey = this.appkey;
      content.tokenString = tokenString;

      // 参数序列化
      let data = utils.queryString(content);

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });

      this.axios({
        method: "POST",
        url: "/addAddress",
        data,
      })
        .then((result) => {
          this.issaving = true;
          this.$toast.clear();

          this.$toast(result.data.msg);
          if (result.data.code == 9000) {
            setTimeout(() => {
              this.issaving = false;
              this.$router.go(-1);
            }, 1500);
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 编辑地址
    editAddress(content) {
      let tokenString = localStorage.getItem("TK");
      if (!toString) {
        return this.$router.push({ name: "Login" });
      }

      //

      // // 判断地址信息是否被修改
      let isModify = false;
      for (let key in this.addressInfo) {
        if (this.addressInfo[key] != content[key]) {
          // 已经被修改
          isModify = true;
          break;
        }
      }
      if (isModify) {
        // 发起修改地址请求

        // 复制对象
        let addressData = Object.assign({}, content);

        delete addressData.country;

        addressData.tokenString = tokenString;
        addressData.appkey = this.appkey;
        addressData.isDefault = Number(addressData.isDefault);

        // 序列化参数
        let data = utils.queryString(addressData);

        this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0,
          loadingType: "spinner",
        });

        this.axios({
          method: "POST",
          url: "/editAddress",
          data,
        })
          .then((result) => {
            this.$toast.clear();

            this.$toast(result.data.msg);
            if (result.data.code == 30000) {
              setTimeout(() => {
                // this.$router.push({ name: "Address" });
                this.$router.go(-1);
              }, 1500);
            }
          })
          .catch((err) => {
            this.$toast.clear();
          });
      } else {
        // this.$router.push({name:'Address'})
        this.$router.go(-1);
      }
    },

    // 保存地址
    saveAddress(address) {
      if (this.aid) {
        // 编辑地址
        this.editAddress(address);
      } else {
        // 新增地址
        this.newAddress(address);
      }
    },

    // 根据aid查询地址数据
    getAddressDataByAid() {
      let tokenString = localStorage.getItem("TK");
      if (!toString) {
        return this.$router.push({ name: "Login" });
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });

      this.axios({
        method: "GET",
        url: "/findAddressByAid",
        params: {
          appkey: this.appkey,
          tokenString,
          aid: this.aid,
        },
      })
        .then((result) => {
          this.$toast.clear();
          //
          if (result.data.code == 40000) {
            for (let key in this.addressInfo) {
              this.addressInfo[key] = result.data.result[0][key];
            }
            this.addressInfo.aid = result.data.result[0].aid;
            this.addressInfo.isDefault = Boolean(
              result.data.result[0].isDefault
            );
            //
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 删除地址
    removeAddress() {
      let tokenString = localStorage.getItem("TK");
      if (!toString) {
        return this.$router.push({ name: "Login" });
      }

      // 参数序列化
      let data = utils.queryString({
        appkey: this.appkey,
        tokenString,
        aid: this.aid,
      });

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });

      this.axios({
        method: "POST",
        url: "/deleteAddress",
        data,
      })
        .then((result) => {
          this.isdelete = true;
          this.$toast.clear();

          this.$toast(result.data.msg);
          if (result.data.code == 10000) {
            setTimeout(() => {
              this.$router.push({ name: "Address" });
              this.isdelete = false;
            }, 1500);
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },
  },
};
</script>